import React, { useState } from "react";

import { signinUser } from "services";

import { mapAppTypeToString, setLocalKlimVar, useAppType, useNavigate, useTranslation } from "utils";

import { SOIL_SIGHT_FLOW_ROUTES } from "consts";

import { Button, Form, Typography } from "components";

import { SignInInputs } from "pages/app/account/components/SignInInputs";
import { trackSoilSightLoginSubmit } from "pages/app/soilsight-pre-login/utils/acquisitionTracking";

interface LoginFormValues {
  email: string;
  password: string;
}

interface LoginStepProps {
  // Mirrors the real /sign-in page's "Create account" button: same step, just the other form.
  onSignupClick: () => void;
}

export const LoginStep = ({ onSignupClick }: LoginStepProps) => {
  const { t } = useTranslation(["scenarioAnalysis", "signinup"]);
  const navigate = useNavigate();
  const appType = useAppType();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitLogin = ({ email, password }: LoginFormValues) => {
    setIsSubmitting(true);
    const controller = new AbortController();

    signinUser({ appType: mapAppTypeToString(appType), email, password, signal: controller.signal })
      .then((res) => {
        setLocalKlimVar("token", res.token);
        trackSoilSightLoginSubmit(true);
        navigate(SOIL_SIGHT_FLOW_ROUTES.scenarios, { state: { entryPoint: "post_login" } });
      })
      .catch(() => {
        trackSoilSightLoginSubmit(false);
        // The global axios handler already showed the failure. We catch so the rejection does not escape.
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="soilsight-acquisition-signup" data-testid="soilsight-step-login">
      <Typography variant="h1" className="soilsight-acquisition-signup__title">
        {t("preLogin.simulation.login.title")}
      </Typography>

      <Form name="soilsight-login" className="soilsight-acquisition-signup__form" onFinish={submitLogin}>
        <SignInInputs />
        <Button type="primary" htmlType="submit" dataTestId="soilsight-login-submit" disabled={isSubmitting} loading={isSubmitting}>
          {t("signinup:signin.buttons.signin")}
        </Button>
        <Button type="secondary" dataTestId="soilsight-login-signup" disabled={isSubmitting} onClick={onSignupClick}>
          {t("signinup:signin.buttons.createAccount")}
        </Button>
      </Form>
    </div>
  );
};
